import type { Dispatch, AnyAction } from 'redux';

import type { UnavailabilityReasonViewModel } from 'ab-viewModels/unavailabilityReason.viewModel';

import type { UnavailabilityReasonScope } from '@acceligentllc/shared/enums/unavailabilityReasonScope';

import type { GetRootState } from 'af-reducers';

import { errorHandler } from 'af-utils/actions.util';
import { http } from 'af-utils/http.util';

import API from 'af-constants/routes/api';

export function findUnavailabilityReasons(query: string, scope: UnavailabilityReasonScope) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.get<UnavailabilityReasonViewModel[]>(API.V1.RESOURCES.UNAVAILABILITY_REASON.LIST(query, scope));
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}
